import { Navigate } from "react-router-dom";
import { useAuth, hasPerm } from "@/lib/auth";

export default function ProtectedRoute({ children, perm }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-ink-muted text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/elder-login" replace />;
  if (perm && !hasPerm(user, perm)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-ink-muted text-sm">
        You do not have permission to access this area.
      </div>
    );
  }
  return children;
}
